export const Chuckle = ({ className = "" }) => (
  <svg viewBox="0 0 200 200" className={className} aria-hidden="true" focusable="false">
    <path d="M100 12C150 10 190 45 188 105C186 160 150 190 100 190C48 190 12 158 12 102C12 46 52 14 100 12Z" fill="#FFC21A" />
    <path d="M56 92Q70 70 84 92M116 92Q130 70 144 92" stroke="#1B1340" strokeWidth="9" strokeLinecap="round" fill="none" />
    <path d="M50 112Q100 128 150 112Q142 172 100 172Q58 172 50 112Z" fill="#1B1340" />
    <path d="M78 160Q100 140 122 160Q100 174 78 160Z" fill="#FF5E8A" />
    <circle cx="40" cy="122" r="10" fill="#FF5E8A" opacity=".55" />
    <circle cx="160" cy="122" r="10" fill="#FF5E8A" opacity=".55" />
  </svg>
);

export const Drip = ({ className = "" }) => (
  <svg viewBox="0 0 200 200" className={className} aria-hidden="true" focusable="false">
    <path d="M100 8C100 8 30 85 30 130C30 168 62 192 100 192C138 192 170 168 170 130C170 85 100 8 100 8Z" fill="#3FA9FF" />
    <circle cx="78" cy="130" r="10" fill="#1B1340" />
    <circle cx="122" cy="130" r="10" fill="#1B1340" />
    <circle cx="81" cy="126" r="3.4" fill="#fff" />
    <circle cx="125" cy="126" r="3.4" fill="#fff" />
    <path d="M62 108L90 116M138 108L110 116" stroke="#1B1340" strokeWidth="6" strokeLinecap="round" />
    <path d="M84 162Q100 148 116 162" stroke="#1B1340" strokeWidth="6.5" strokeLinecap="round" fill="none" />
    <path d="M130 146C130 146 122 156 122 161C122 166 126 169 130 169C134 169 138 166 138 161C138 156 130 146 130 146Z" fill="#D8EEFF" />
  </svg>
);

export const Shiver = ({ className = "" }) => (
  <svg viewBox="0 0 200 200" className={className} aria-hidden="true" focusable="false">
    <path d="M100 10C145 10 177 46 177 96L177 186L152 168L126 190L100 168L74 190L48 168L23 186L23 96C23 46 55 10 100 10Z" fill="#8A4DFF" />
    <circle cx="74" cy="86" r="19" fill="#fff" />
    <circle cx="126" cy="86" r="19" fill="#fff" />
    <circle cx="68" cy="90" r="6.5" fill="#1B1340" />
    <circle cx="120" cy="90" r="6.5" fill="#1B1340" />
    <ellipse cx="100" cy="132" rx="11" ry="16" fill="#1B1340" />
  </svg>
);

export const CHARACTERS = { Chuckle, Drip, Shiver };

export const Bob = ({ delay = 0, className = "", children }) => (
  <span className={`bob inline-block ${className}`} style={{ animationDelay: `${delay}s` }}>
    {children}
  </span>
);

export const OnInk = ({ children, className = "" }) => (
  <span className={`grid place-items-center rounded-full bg-ink ${className}`}>{children}</span>
);
